<!--COMMON SEARCH INPUT-->
<!--NOTE: Used in header and search page-->
<div class="search-container">
  <form class="search-form" [formGroup]="catalogSearchForm" (ngSubmit)="onSearch()">
    <label for="catalog-search" class="sr-only">Search the Catalog:</label>
    <!--SEARCH INPUT-->
    <!--NOTE: ngModelChange must have ngModel to work. This is different from change vs ngModelChange which effets the @Output emitter-->
    <input
      type="search"
      #searchQuery
      [(ngModel)]="searchQueryData"
      (ngModelChange)="onChange($event)"
      [placeholder]="searchPlaceholderMessage"
      formControlName="catalogSearchQuery"
      [value]="searchQueryData"
      class="search-field"
      [ngClass]="[hideSearchBlock ? 'search-field' : 'search-field-show']" />
    <!--SUBMIT SEARCH-->
    <input class="sr-only" type="submit" value="Search" />
  </form>
</div>
<!--END COMMON SEARCH INPUT-->
